import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Landing target for the "manage your notification preferences" email link.
//
// This used to auto-fire an unauthenticated PATCH on mount, so any mail
// scanner / link-preview bot / accidental click silently disabled a client's
// lead notifications. It now mutates nothing: it only routes the visitor to
// the authenticated Settings page where they can explicitly change the
// preference. Logged-out visitors are sent through login first and bounced
// back to Settings afterwards.

// Each role's settings route — these paths must exist in that role's route
// block in App.js, or the post-login redirect lands on the 404 catch-all.
const SETTINGS_PATH_BY_ROLE = {
  Client: "/clientsettings",
  "Team Member": "/teammembersettings",
  "Super Client": "/superclientsettings",
  Admin: "/settings",
  "Account Manager": "/settings",
};

function NotificationPreferences() {
  const user = useSelector((state) => state.auth.user);

  if (!user) {
    // We don't know the visitor's role yet, so bounce back HERE after login
    // (this route is registered for everyone) and decide then. Storing a
    // role-specific path here sent non-Client roles to a 404.
    localStorage.setItem("postLoginRedirect", "/notification-preferences");
    return <Navigate to="/login" replace />;
  }

  const settingsPath = SETTINGS_PATH_BY_ROLE[user.role];
  if (settingsPath) {
    return <Navigate to={settingsPath} replace />;
  }

  // Remaining roles (Financial Manager, Media Buyers) don't receive lead
  // emails — send them to their role home.
  return <Navigate to="/" replace />;
}

export default NotificationPreferences;
